/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Event_Track_Select_Aria_LabelInputs */



/**
* | output |
* | --- |
* | "Assign event to a track" |
*
* @param {Event_Track_Select_Aria_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const event_track_select_aria_label = /** @type {((inputs?: Event_Track_Select_Aria_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Event_Track_Select_Aria_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Attribuer un événement à une piste")
	if (locale === "de") return /** @type {LocalizedString} */ ("Weisen Sie ein Ereignis einer Spur zu.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Assegna l'evento a una traccia")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Присвоить событие треку")
	if (locale === "es") return /** @type {LocalizedString} */ ("Asignar evento a una pista")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("将事件分配到赛道")
	if (locale === "ja") return /** @type {LocalizedString} */ ("イベントをトラックに割り当てる")
	if (locale === "hi") return /** @type {LocalizedString} */ ("किसी ट्रैक को इवेंट असाइन करें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Atribuir evento a uma faixa")
	return /** @type {LocalizedString} */ ("Assign event to a track")
});